import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class LayoutGallery extends kr.Component {
    async init() {
        this._toRun = ['.js_gallery', '.wp-block-gallery'];
        this._countGallery = 0;
        this._GLightbox = await import('glightbox/src/js/glightbox');
        this._GLightbox = this._GLightbox.default;

        this._run();
    }

    _run() {
        for (let i in this._toRun) {
            this._enableGalleryFor(this._toRun[i]);
        }
    }

    _enableGalleryFor(name) {
        const $el = this.$element.querySelectorAll(name);
        if ($el.length == 0) {
            return false;
        }

        for (let i in $el) {
            if ($el[i] == $el.length) return;
            this._countGallery++;
            HTMLClass.addClass($el[i], `js_gallery-${this._countGallery}`);
            new this._GLightbox({
                'selector': `.js_gallery-${this._countGallery} a`,
            });
        }
    }
}

kr.registerComponent('.web__root', {
    component: LayoutGallery
});